// src/routes/RequerimientoRoutes.jsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import RequerimientoPage from "../pages/RequerimientoPage";
import RequerimientoDetalle from "../pages/RequerimientoDetalle";
import RequerimientosEsperaPlataformaPage from "../pages/RequerimientosEsperaPlataformaPage";
const RequerimientoRoutes = () => {
  return (
    <Routes>
      
      <Route path="" element={<RequerimientoPage />} />
      <Route path="pendientes-plataforma" element={<RequerimientosEsperaPlataformaPage />} />
      <Route path=":cod" element={<RequerimientoDetalle />} /> 
    </Routes>
  );
};

export default RequerimientoRoutes;
